export const ADD_DETAIL = (state, { key, value }) => {
  state._[key] = value
  state.list.push(key)
}

export const EDIT_DETAIL = (state, { key, value }) => {
  if (!state.list.some(k => k === key)) return
  state._[key] = value
  state.list = state.list.filter(x => true)
}

export const DELETE_DETAIL = (state, { key }) => {
  state.list = state.list.filter(k => k !== key)
  delete state._[key]
}
